<template>
    <div class="d-react">
        <button :ref="'react-button-' + id" :class="class_act" v-if="!display_act" @click="open_act">
            <v-icon size="15" v-if="act===''">sentiment_satisfied_alt</v-icon>
            <span class="s-icon" v-if="act==='👍'">👍</span>
            <span class="s-icon" v-if="act==='👎'">👎</span>
        </button>
        <div class="d-select-react" 
            :class="{ animeshow: display_act }" 
            v-if="display_act" 
            v-closable="{ exclude: [id], handler: 'closeAct'}">
            <v-btn class="btn-react-like" icon small color="blue" @click="react('👍')">
                <!-- <v-icon size="12" color="blue">thumb_up</v-icon> -->
                <span class="s-icon">👍</span>
            </v-btn>
            <v-btn class="btn-react-dislike" icon small color="red" @click="react('👎')">
                <!-- <v-icon size="12" color="red">thumb_down</v-icon> -->
                <span class="s-icon">👎</span>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import handerMessage from '../../business/handler_messages'
    export default {
        name    : 'react-button',
        props: {
            message_id: '',
            user_act: ''
        },
        data() {
            return {
                id: this.uuidv4(),
                display_act: false,
                act: '',
                class_act: 'btn-react',
            }
        },
        mounted() {
            // console.log(this.message_id)
            if (this.user_act !== '') {
                this.act = this.user_act
                this.class_act = 'btn-react-ed'
            }
        },
        methods: {
            open_act() {
                this.display_act = true;
            },
            async react(act) {
                if (this.act === act) {
                    this.act = ''
                    this.class_act = 'btn-react'
                } else {
                    this.act = act
                    this.class_act = 'btn-react-ed'
                }
                this.display_act = false

                await handerMessage.send_react(this.$store.state.botCode, this.$store.state.clientId, this.$store.state.clientToken, this.message_id, this.act);

            },
            closeAct() {
                // this.class_act = 'btn-react-ed'
                if (this.act !== '') {
                    this.class_act = 'btn-react-ed'
                } else {
                    this.class_act = 'btn-react'
                }
                this.display_act = false
            },
            uuidv4() {
                return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
                );
            }
        }
    }
</script>

<style scoped>
    .animeshow {
        /* width: 0px; */
        animation: showoff 0.2s ease-in;

    }
    @keyframes showoff {
        0% {
            width: 28px;
        }
        /* 50% {
            width: 20px;
        } */
        100% {
            width: 56px;
        }
    }
</style>